import { SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_advertContext_TrackingAdvertContext } from '../../contexts/search-results-context/query/__generated__/search-results-listings.fed.query'
import { AdvertContext202 } from '@at/track-types'

export const advertContext = (
    advertContext: SearchResultsListingsGridQuery_searchResults_SearchResults_listings_SearchListing_trackingContext_TrackingContext_advertContext_TrackingAdvertContext
): AdvertContext202 => {
    return {
        SCHEMA_KEY: 'AdvertContext202',
        id: advertContext.id || '',
        advertiser_id: advertContext.advertiserId,
        advertiser_type: advertContext.advertiserType,
        make: advertContext.make,
        model: advertContext.model,
        vehicle_category: advertContext.vehicleCategory || undefined,
        year: advertContext.year,
        condition: advertContext.condition,
        price: advertContext.price,
    }
}
